import React from 'react';
import { createPortal } from 'react-dom';
import { X } from './icons';
import EvidenceItem from './EvidenceItem';
import EvidenceModal from './EvidenceModal';
import { downloadEvidenceViaAPI } from '../utils/evidenceProxy';

export default function AttachmentsModal({ ticket, onClose }) {
    const [selectedEvidence, setSelectedEvidence] = React.useState(null);
    const [showEvidenceModal, setShowEvidenceModal] = React.useState(false);

    if (!ticket || !ticket.archivos || ticket.archivos.length === 0) return null;

    const handleViewOrDownload = (archivo) => {
        const url = archivo.rutaArchivo || `/securefile/preview/evidencias/${archivo.nombreArchivo}`;
        const isImage = archivo.tipoMime && archivo.tipoMime.startsWith('image/');

        if (isImage) {
            setSelectedEvidence({ url, name: archivo.nombreOriginal });
            setShowEvidenceModal(true);
        } else {
            downloadEvidenceViaAPI(url, archivo.nombreOriginal);
        }
    };

    const handleCloseEvidence = () => {
        setShowEvidenceModal(false);
        setSelectedEvidence(null);
    };

    return createPortal(
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50" onClick={(e) => e.stopPropagation()}>
            <div className="bg-white dark:bg-gray-800 rounded-lg w-full max-w-2xl shadow-xl transform transition-all flex flex-col max-h-[90vh]" onClick={(e) => e.stopPropagation()}>

                {/* Header */}
                <div className="flex justify-between items-center p-6 border-b border-gray-200 dark:border-gray-700">
                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                        Archivos Adjuntos - Ticket #{ticket.id}
                    </h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 focus:outline-none"
                    >
                        <X className="w-6 h-6" />
                    </button>
                </div>

                {/* Content */}
                <div className="p-6 overflow-y-auto flex-1">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {ticket.archivos.map((archivo, index) => (
                            <div key={index}>
                                <EvidenceItem
                                    // Utilizar la ruta tal cual viene del servicio, compatible con el proxy del frontend
                                    url={archivo.rutaArchivo || `/securefile/preview/evidencias/${archivo.nombreArchivo}`}
                                    name={archivo.nombreOriginal}
                                    mime={archivo.tipoMime}
                                    size={archivo.tamanoBytes || archivo.tamañoBytes}
                                    onView={() => handleViewOrDownload(archivo)}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Footer */}
                <div className="bg-gray-50 dark:bg-gray-700/30 px-6 py-4 rounded-b-lg flex justify-end">
                    <button
                        type="button"
                        onClick={onClose}
                        className="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white dark:bg-gray-600 dark:text-white border border-gray-300 dark:border-gray-500 rounded-md shadow-sm hover:bg-gray-50 dark:hover:bg-gray-500 focus:outline-none"
                    >
                        Cerrar
                    </button>
                </div>
            </div>

            <EvidenceModal
                isOpen={showEvidenceModal}
                onClose={handleCloseEvidence}
                evidenceUrl={selectedEvidence?.url}
                evidenceName={selectedEvidence?.name}
            />
        </div>,
        document.body
    );
}
